import mixpanel from 'mixpanel-browser';
import api from '../../../lib/api';

const mixToken = process.env.VUE_APP_MIXPANEL_TOKEN;
mixpanel.init(mixToken);

export default {
  async get({ state, commit }, { page, size }) {
    const { email, company } = state;
    const { accountNumber } = company;
    const payload = await api.users.getUsers(size, page, email || null, accountNumber || null);

    const {
      count,
      totalCount,
      totalPages,
      rows,
    } = payload;

    commit('setValues', {
      count,
      totalCount,
      totalPages,
      list: rows,
    });

    return payload;
  },

  async getAll() {
    const payload = await api.users.getAll();
    const body = document.querySelector('body');

    const download = document.createElement('a');
    const downloadUrl = URL.createObjectURL(payload);

    download.setAttribute('href', downloadUrl);
    download.setAttribute('download', 'users_report.csv');
    download.style.display = 'none';

    body.appendChild(download);

    download.click();

    return 'users_report.csv';
  },

  async create({ rootState, commit }) {
    const {
      name,
      sendEmail,
      company,
      email,
      role,
      phoneNumber = '0000000000',
    } = rootState.users;

    const {
      rfc,
      tradeName,
      accountNumber,
      projectName,
      name: companyName,
      multiUser,
    } = company;

    const data = {
      email,
      name,
      rfc,
      tradeName,
      accountNumber,
      projectName,
      companyName,
      role,
      phoneNumber,
      multiUser,
    };

    const payload = await api.users.createUser(data, sendEmail);

    commit('setValues', {
      email: '',
      name: '',
      company: {
        rfc: '',
        name: '',
        tradeName: '',
        accountNumber: '',
        projectName: '',
        multiUser: '',
      },
    });

    return payload;
  },

  async csvLoad({ state, commit }) {
    const { csv } = state;

    const formData = new FormData();
    formData.append('file', csv);

    const payload = await api.users.csvLoad(formData);

    commit('setValues', { csv: null, csvFileName: '' });
    commit('setValues', {
      list: payload,
      loading: false,
    });

    return payload;
  },
  async updateOwnUser({ rootState }, user) {
    const payload = await api.users.updateOwnUser(user);

    if (user.phoneNumber !== user.oldData.phoneNumber) {
      mixpanel.track('Actualización número de teléfono', {
        distinct_id: rootState.auth.subscriberId || rootState.company.rfc,
        PhoneNumber: user.phoneNumber,
      });

      mixpanel.people.set({
        phone_number: user.phoneNumber,
      });
    }

    return payload;
  },

  async update({ state, commit }) {
    const {
      userId,
      name,
      email,
      company,
      phoneNumber,
    } = state;

    const {
      employerRegistration,
      oldRfc,
      rfc,
      name: companyName,
      tradeName,
      accountNumber,
      projectName,
      multiUser,
    } = company;

    const promises = [
      api.users.updateUser({
        userId,
        email,
        name,
        tradeName,
        accountNumber,
        projectName,
        companyName,
        employerRegistration,
        phoneNumber,
        multiUser,
      }),
    ];

    if (oldRfc !== rfc) promises.push(api.users.updateRfc({ userId, rfc, oldRfc }));

    const payload = await Promise.all(promises);

    commit('setValues', {
      userId: 0,
      email: '',
      name: '',
      rfc: '',
      companyName: '',
      tradeName: '',
      accountNumber: '',
      projectName: '',
      oldRfc: '',
      employerRegistration: '',
      multiUser: '',
    });

    return payload;
  },

  async createSecondary({ rootState, commit }) {
    const {
      name,
      email,
    } = rootState.users;

    const { companyId } = rootState.auth;

    const data = {
      email,
      name,
    };

    const payload = await api.users.createSecondaryUser(data, companyId);

    commit('setValues', {
      email: '',
      name: '',
    });

    return payload;
  },

  async updateSecondary({ rootState, commit }, secondaryId) {
    const {
      name,
      email,
    } = rootState.users;

    const { id } = rootState.auth;

    const data = {
      email,
      name,
    };

    const payload = await api.users.updateSecondaryUser(data, id, secondaryId);

    commit('setValues', {
      email: '',
      name: '',
    });

    return payload;
  },

  sendSecondarySignInEmail(store, secondaryId) {
    return api.users.sendSecondarySignInEmail(secondaryId);
  },

  async getSecondary({ commit }, { page, size }) {
    const payload = await api.users.getSecondaryUsers(size, page);

    const {
      count,
      totalCount,
      totalPages,
      rows,
    } = payload;

    commit('setValues', {
      count,
      totalCount,
      totalPages,
      list: rows,
    });

    return payload;
  },

  async getSingleSecondary({ commit }, secondaryId) {
    const payload = await api.users.getSecondaryUser(secondaryId);

    const {
      name,
      email,
    } = payload;

    commit('setValues', {
      name,
      email,
    });

    return payload;
  },

  async deleteSingleSecondary({ rootState }, secondaryId) {
    const { id } = rootState.auth;

    const payload = await api.users.deleteSingleSecondary(id, secondaryId);

    return payload;
  },

};
